import React from 'react';
import { Phone, Mail, Instagram, Clock, MapPin } from 'lucide-react';

const ContactSection = () => {
  const handleWhatsAppClick = () => {
    window.open('https://wa.me/5518998086169?text=Ol%C3%A1%2C%20gostaria%20de%20agendar%20uma%20sess%C3%A3o', '_blank');
  };

  const handleEmailClick = () => {
    window.location.href = 'mailto:gizeliterapeuta@gmail.com';
  };

  const handleInstagramClick = () => {
    window.open('https://instagram.com/gizeli.terapeuta', '_blank');
  };

  return (
    <section id="contato" className="py-24 bg-gradient-to-b from-white to-blue-50">
      <div className="container mx-auto px-4">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-blue-900 mb-4">Agende Sua Sessão</h2>
            <div className="w-24 h-1 bg-blue-600 mx-auto rounded-full mb-6"></div>
            <p className="text-xl text-gray-600">
              Entre em contato e dê o primeiro passo para sua transformação
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-12">
            {/* Contact Info */}
            <div className="space-y-6">
              <div className="bg-gradient-to-br from-blue-600 to-blue-700 text-white p-8 rounded-2xl shadow-xl">
                <h3 className="text-2xl font-bold mb-6">Entre em Contato</h3>
                
                <div className="space-y-4">
                  <div className="flex items-start gap-4">
                    <div className="bg-white/20 p-3 rounded-full">
                      <Phone size={24} />
                    </div>
                    <div>
                      <p className="text-blue-100 text-sm mb-1">WhatsApp</p>
                      <a
                        href="https://wa.me/5518998086169"
                        className="text-white font-semibold text-lg hover:text-blue-100 transition-colors"
                      >
                        (18) 99808-6169
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="bg-white/20 p-3 rounded-full">
                      <Mail size={24} />
                    </div>
                    <div>
                      <p className="text-blue-100 text-sm mb-1">E-mail</p>
                      <a
                        href="mailto:gizeliterapeuta@gmail.com"
                        className="text-white font-semibold hover:text-blue-100 transition-colors break-all"
                      >
                        gizeliterapeuta@gmail.com
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="bg-white/20 p-3 rounded-full">
                      <Instagram size={24} />
                    </div>
                    <div>
                      <p className="text-blue-100 text-sm mb-1">Instagram</p>
                      <a
                        href="https://instagram.com/gizeli.terapeuta"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-white font-semibold hover:text-blue-100 transition-colors"
                      >
                        @gizeli.terapeuta
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start gap-4">
                    <div className="bg-white/20 p-3 rounded-full">
                      <MapPin size={24} />
                    </div>
                    <div>
                      <p className="text-blue-100 text-sm mb-1">Atendimento</p>
                      <p className="text-white font-semibold">Online</p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="bg-white p-6 rounded-2xl shadow-lg border border-blue-100">
                <div className="flex items-center gap-3 mb-3">
                  <Clock className="text-blue-600" size={24} />
                  <h4 className="text-lg font-bold text-blue-900">Horário de Atendimento</h4>
                </div>
                <p className="text-gray-600">
                  Entre em contato para verificar disponibilidade e agendar sua sessão.
                </p>
              </div>
            </div>

            {/* CTA Card */}
            <div className="space-y-6">
              <div className="bg-white p-8 rounded-2xl shadow-xl border border-blue-100 h-full flex flex-col justify-center">
                <div className="text-center">
                  <div className="w-20 h-20 bg-blue-100 rounded-full flex items-center justify-center mx-auto mb-6">
                    <Phone className="text-blue-600" size={40} />
                  </div>
                  <h3 className="text-3xl font-bold text-blue-900 mb-4">
                    Pronta para começar?
                  </h3>
                  <p className="text-gray-600 mb-8 text-lg">
                    Agende sua primeira sessão agora e inicie sua jornada de transformação.
                  </p>
                  <button
                    onClick={handleWhatsAppClick}
                    className="w-full bg-green-500 hover:bg-green-600 text-white py-4 px-8 rounded-full font-semibold text-lg transition-all duration-300 shadow-lg hover:shadow-xl hover:scale-105 flex items-center justify-center gap-3"
                  >
                    <Phone size={24} />
                    Agendar via WhatsApp
                  </button>
                  <p className="text-sm text-gray-500 mt-4">
                    Resposta rápida e atendimento personalizado
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Additional Info */}
          <div className="mt-16 bg-blue-50 border border-blue-200 p-8 rounded-2xl">
            <div className="text-center max-w-3xl mx-auto">
              <h3 className="text-2xl font-bold text-blue-900 mb-4">
                Primeira Sessão
              </h3>
              <p className="text-gray-700 leading-relaxed">
                Na primeira sessão, vamos conversar sobre seus objetivos, desafios e expectativas. 
                É um momento de acolhimento onde você poderá entender como a terapia pode te ajudar 
                e como será nosso trabalho juntas.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;